import React from 'react'

import { useSetRecoilState } from 'recoil'

import styled from '@emotion/styled'

import { modalBeeContentDialogState } from '../recoil/state'

import svgload from 'Helpers/svgload'

import IconArrowLeft from 'mailup-web-components/src/img/icons/arrow-left.svg?raw'

const StyledBack = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  left: 30px;
  border: 0;
  outline: none;
  width: 32px;
  height: 32px;
  color: var(--boulder);
  background-color: transparent;

  cursor: pointer;

  transition: background-color 0.2s ease-out;

  &::before {
    content: '';
    display: inline-block;
    width: 32px;
    height: 32px;
    background-image: ${svgload(IconArrowLeft, { path: { fill: '#7c7c7c' } })};
    background-repeat: no-repeat;
    background-size: 22px;
    background-position: center;
  }

  &:hover {
    background-color: var(--wild-sand);
    border-radius: 16px;
  }
`

const BackButton = () => {
  const setModalState = useSetRecoilState(modalBeeContentDialogState)
  const handleBack = () =>
    setModalState(prev => ({ ...prev, step: 1, selectedContents: {} }))

  return <StyledBack onClick={handleBack} />
}

export default BackButton
